<template> 
    <div class="contact">
        <!-- Banner -->
        <Banner name="banner_aboutus" />

        <!-- 大会简介 -->
        <div class="about">
            <div class="contact-title">{{ aboutData.title }}</div>
            <div class="about-summary">{{ aboutData.summary }}</div>
            <div class="about-content" v-html="aboutData.content"></div>
            <div class="about-list">
                <div v-for="(item, index) in aboutData.list" :key="index">
                    <div class="item" v-if="index < 3" @click="handleClick(item.link_url)">
                        <div class="item-title">
                            <div class="item-img">
                                <img :src="item.image_url">
                            </div>
                            <div class="title">{{ item.title }}</div>
                        </div>
                        <div class="item-summary">{{ item.summary }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 商务合作 -->
        <div class="business">
            <div class="business-bg">
                <div class="contact-title">{{ businessData.title }}</div>
                <div class="business-sroll">
                    <Carousel :slides="businessData.list">
                        <template #slide="{ slide }">
                            <div class="business-carousel">
                                <img :src="slide.image_url" class="business-img">
                                <div class="business-conent" v-if="slide.title || slide.summary">
                                    <div class="title">{{ slide.title }}</div>
                                    <div class="summary">{{ slide.summary }}</div>
                                </div>        
                            </div>
                        </template>
                    </Carousel>
                </div>
            </div>
        </div>

        <!-- 联系我们 -->
        <div class="contact-us">
            <div class="contact-title">{{ contactData.title }}</div>
            <div class="contact-us-info">
                <div class="items">
                    <div class="item">
                        <img src="@/assets/footer/icon_address.png" srcset="@/assets/footer/icon_address@2x.png 2x" />
                        {{ contactData.address }}
                    </div>
                    <div class="item">
                        <img src="@/assets/footer/icon_email.png" srcset="@/assets/footer/icon_email@2x.png 2x" />
                        {{ contactData.email }}
                    </div>
                </div>
                

                <img :src="contactData.map_image_url" class="contact-us-map"/> 
            </div>
        </div>
    </div> 
</template>

<script setup>
    import Carousel from '@/components/carousel/index.vue'
    import Banner from '@/components/banner/index.vue'
    import { onMounted, ref } from 'vue';
    import { ConfigGetAPI } from '@/api/common.js';
    import { useRouter } from 'vue-router'
    const router = useRouter()

    // 大会简介参数
    const aboutParam = ref({ name: "about_introduction" })

    // 大会简介数据
    const aboutData = ref({})

    // 大会简介数据获取
    const getAboutData = () =>{
        ConfigGetAPI(aboutParam.value).then(res=>{
            aboutData.value = res
        });
    }

    // 商务合作
    const businessParam = ref({ name: "about_center" })

    // 商务合作数据
    const businessData = ref({ list:[] })

    // 商务合作数据获取
    const getBusinessData = () => {
        ConfigGetAPI(businessParam.value).then(res => {
            businessData.value = res
        });
    }

    // 联系我们
    const contactParam = ref({ name: "about_contact" })

    // 联系我们数据
    const contactData = ref({})

    // 联系我们数据获取
    const getContactData = () => {  
        ConfigGetAPI(contactParam.value).then(res => {
            contactData.value = res
        });
    }

    onMounted(() => {
        getAboutData();
        getBusinessData();
        getContactData();
    });

    // 点击跳转
    const handleClick = (path) => {
        router.push({ path })
    }

</script>

<style lang="scss" scoped>

.contact {
    &-title {
        font-family: PingFangSC-medium;
        color: #333333;
        font-weight: 500;
        font-size: 36px;
        letter-spacing: 3px;
        line-height: 56px;    
    }

    .banner-img {
        width: 100%;
        height: 600px;
        object-fit: cover;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;

        .title {
            position: absolute;
            top: 50%;    

        }    
    }

    .about {
        background-color: #fff;
        padding: 100px 0 80px 0;
        width: 1200px;
        margin: 0 auto;

        &-summary {
            margin-top: 16px;
            font-family: PingFangSC-medium;
            color: #333333;
            font-weight: 500;
            font-size: 28px;
            letter-spacing: 2px;
            
        }

        &-content {
            font-family: PingFangSC-regular;
            color: #333333;
            font-weight: 400;
            font-size: 24px;
            letter-spacing: 2px;
            margin-top: 10px;
        }

        &-list {
            margin-top: 40px;
            display: flex;
            align-items: center;
            justify-content: space-between;


            .item {
                width: 384px;
                border-radius: 30px;
                background-color: #F8FAFC;
                padding: 24px;
                box-sizing: border-box;
                cursor: pointer;

                &-title {
                    font-family: PingFangSC-medium;
                    color: #333333;
                    font-weight: 500;
                    font-size: 30px;
                    letter-spacing: 3px;
                    display: flex;
                    align-items: center;

                    .title {
                        max-width: 200px;
                    }
                }

                &-img {
                    width: 75px;
                    height: 75px;
                    background-color: #FFFFFF;
                    border-radius: 65px;
                    margin-right: 27px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                &-summary {
                    font-family: PingFangSC-regular;
                    color: #333333;
                    font-weight: 400;
                    font-size: 20px;
                    letter-spacing: 2px;
                    margin-top: 24px;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    
                }

                &-summary:hover {
                    text-decoration: underline;
                }
            }
        }
    }

    .business {
        background-color: #F8FAFC;
        padding: 50px 0;
        
        &-bg {
            width: 1200px;
            margin: 0 auto;
        }

        &-sroll{
            margin: 36px 0;
        }

        &-carousel {
            position: relative;
            width: 1200px;
            height: 675px;
        }

        &-conent {
            position: absolute;
            bottom: 0px;
            width: 1200px;
            height: 197px;
            background-color: rgba(6, 6, 6, 0.5);
            border-radius: 0 0 30px 30px;
            box-sizing: border-box;
            padding: 28px 50px;
            color: #FFFFFF;

            .title {
                font-family: PingFangSC-medium;
                font-weight: 500;
                font-size: 24px;
                letter-spacing: 2px;
                line-height: 33px;
            }

            .summary {
                font-weight: 400;
                font-size: 20px;
                letter-spacing: 2px;
                line-height: 40px;
            }
        }

        &-img {
            width: 1200px;
            height: 675px;
            border-radius: 30px;
            // object-fit: cover;
        }
    }

    .contact-us {
        background-color: #fff;
        padding: 80px 0 50px 0;
        width: 1200px;
        margin: 0 auto;
        
        &-info {
            display: flex;
            justify-content: space-between;
            margin-top: 36px;

            .items {
                margin-top: 64px;
            }

            .item {
                color: #666666;
                font-weight: 400;
                font-size: 20px;
                letter-spacing: 2px;
                margin-bottom: 24px;
                display: flex;
                align-items: center;
                max-width: 500px;

                img {
                    margin-right: 17px;
                }
            }
        }

        &-map {
            width: 720px;
            // height: 360px;
            border-radius: 30px;
        }
    }
}
/* 响应式布局 */
@media (max-width: 768px) {
    .contact {
        
        &-title {
            font-family: PingFangSC-medium;
            color: #333333;
            font-weight: 600;
            font-size: 18px; 
            line-height: 24px;  
        }

        .about {
            background-color: #fff;
            padding: 24px 12px;
            width: 100%;
            box-sizing: border-box;
            
            &-summary {
                margin-top: 8px;
                font-family: PingFangSC-medium;
                color: #333;
                font-weight: 400;
                font-size: 12px;
                letter-spacing: 2px;
            }

            &-content {
                font-family: PingFangSC-regular;
                color: #333333;
                font-weight: 400;
                font-size: 10px;
                letter-spacing: 2px;
                margin-top: 10px;
            }

            &-list {
                margin-top: 0px;
                display: block;
                // flex-direction: column;
                margin: 8px 0;
                width: 100%;

                .item {
                    width: 100% !important;
                    height: auto;
                    border-radius: 12px;
                    background-color: #F8FAFC;
                    margin: 6px 0;
                    padding: 12px;
                    box-sizing: border-box;

                    &-title {
                        font-family: PingFangSC-medium;
                        color: #333333;
                        font-weight: 500;
                        font-size: 16px;
                        letter-spacing: 1px;
                        line-height: 45px;
                        display: flex;
                        align-items: center;
                    }

                    &-img {
                        width: 45px;
                        height: 45px;
                        background-color: #FFFFFF;
                        border-radius: 50%;
                        margin-right: 15px;

                        img {
                            width: 20px;
                            height: 20px;
                        }
                    }

                    &-summary {
                        color: #333333;
                        font-weight: 400;
                        font-size: 14px;
                        letter-spacing: 1px;
                        margin-top: 12px;
                    }
                }
            }
        }

        .business {
            background-color: #F8FAFC;
            padding: 24px 12px;
            
            &-bg {
                width: 100%;
                margin: 0;
            }

            &-sroll{
                margin: 12px 0;
            }

            &-carousel {
                position: relative;
                width: 100%;
                height: 200px;
            }

            &-conent {
                position: absolute;
                bottom: 0px;
                width: 100%;
                height: 80px;
                background-color: rgba(6, 6, 6, 0.5);
                border-radius: 0 0 10px 10px;
                box-sizing: border-box;
                padding: 12px;
                color: #FFFFFF;

                .title {
                    font-family: PingFangSC-medium;
                    font-weight: 500;
                    font-size: 16px;
                    letter-spacing: 1px;
                    line-height: 18px;
                }

                .summary {
                    font-weight: 400;
                    font-size: 12px;
                    letter-spacing: 1px;
                    line-height: 16px;
                    margin-top: 5px;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }

            &-img {
                width: 100%;
                height: 200px;
                border-radius: 10px;
            }
        }

        .contact-us {
            background-color: #fff;
            padding: 24px 12px;
            width: 100%;
            box-sizing: border-box;
            
            &-info {
                display: block;
                margin-top: 0;

                .items {
                    margin-top: 24px;
                }

                .item {
                    color: #666666;
                    font-weight: 400;
                    font-size: 14px;
                    letter-spacing: 1px;
                    margin-bottom: 12px;
                    display: flex;
                    align-items: center;
                    max-width: calc(100% - 40px);

                    img {
                        margin-right: 8px;
                        width: 16px;
                        height: 16px;
                    }
                }
            }

            &-map {
                width: 100%;
                // height: 180px;
                border-radius: 12px;
            }
        }
    }
}

</style>
    

